import React from 'react';
import { Box, Grid } from '@mui/material';
import { CreatePipelineFormData } from '../create-or-update-pipeline-helper';
import { Controller } from 'react-hook-form';
import { TextField } from '@biq/apex-ui';
import { LabelAndValueComponent } from 'pages/wallets-and-groups/components/create-or-edit-user-wallet/user-wallet-from-helper';
import { pipelineFormStyles } from './pipeline-form-helper';

interface PipelineFormDataProps {
    control: any;
    errors: Record<string, any>;
    pipelineFormValues?: CreatePipelineFormData;
    isEdit: boolean;
    handleUnsavedChanges?: () => void;
}

export const PipelineForm = ({
    control,
    errors,
    pipelineFormValues,
    isEdit,
    handleUnsavedChanges,
}: PipelineFormDataProps): React.JSX.Element => {
    return (
        <Grid
            sx={{
                ...pipelineFormStyles.mainContainer,
                mx: isEdit ? '0px' : '143.5px',
            }}
        >
            <Box sx={pipelineFormStyles.fieldGroup}>
                <Controller
                    name='name'
                    control={control}
                    render={({ field }): React.JSX.Element => (
                        <TextField
                            {...field}
                            variant='outlined'
                            label='Name'
                            value={field.value ?? pipelineFormValues?.name}
                            onChange={(event): void => {
                                field.onChange(event);
                                handleUnsavedChanges?.();
                            }}
                            onBlur={(value): void => {
                                field.onChange(value.target.value.trim());
                            }}
                            required
                            error={!!errors?.name}
                            errorText={errors?.name?.message ?? ''}
                        />
                    )}
                />
            </Box>

            <Box sx={pipelineFormStyles.fieldGroup}>
                <Controller
                    name='description'
                    control={control}
                    render={({ field }): React.JSX.Element => (
                        <TextField
                            {...field}
                            variant='outlined'
                            label='Description'
                            value={
                                field.value ?? pipelineFormValues?.description
                            }
                            onChange={(event): void => {
                                field.onChange(event);
                                handleUnsavedChanges?.();
                            }}
                            onBlur={(value): void => {
                                field.onChange(value.target.value.trim());
                            }}
                            minRows={4}
                            multiline
                            error={!!errors?.description}
                            errorText={errors?.description?.message ?? ''}
                        />
                    )}
                />
            </Box>

            {isEdit && (
                <Box sx={{ ...pipelineFormStyles.fieldGroup, mt: 0 }}>
                    <LabelAndValueComponent
                        label='ID'
                        value={pipelineFormValues?.id ?? ''}
                    />
                </Box>
            )}
        </Grid>
    );
};
